import { Component } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { CommonEventService } from '../services/common-event.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-component-procurement',
  templateUrl: './component-procurement.component.html',
  styleUrls: ['./component-procurement.component.css']
})
export class ComponentProcurementComponent {
  
  showPurchaseData = true;
  selectedMpnData :any;
  resolveData :any;
  conversionData:any;
  postConversation:any;
  assistSubmitMsg = false;
  selectedResolId:any;
  resolveDataDuplicate:any;
  selectedResolObj :any;
  level1Errors :any = [];
  closeResult: string = '';
  viaInPadCheckHidden = true;
  changedPcbTT:any;
  currentDateTime:any;
  selectedDniItem:any = {};
  levelOneIssueData:any = {};
  flowActivityId='';
  finalBomAttachData :any = [];

  constructor(private modalService: NgbModal,
    public apiService : ApiService,
    public commonService : CommonEventService,
    private router: Router,
    public formBuilder : FormBuilder){

  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.commonService.formattingCurrentDateTime();
    this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
    var cppInitData={
      "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
    }
    this.apiService.updateDetailsToDashboard(this.flowActivityId,cppInitData,'ComponentProcurementPage').subscribe((resDatas)=>{
    },err=>{
      console.log(err)
    });
    this.commonService.restrictBrowserButtons();
    this.commonService.restrictRefreshButton();
    if(this.commonService.commonMainObj.backToCPPPage){
      this.getUpdatedBomProcureData('sierraRecommData');
    }
    else{
      setTimeout(()=>{
        $("#sierraSugAlt").trigger('click');
      },1000);
    }
  }

  ngOnDestroy() {
    this.commonService.destroyRefreshEvent();
  }
  
  showHidePurcData(){
    this.showPurchaseData = this.showPurchaseData?false:true;
  }
  
  lineItemChange(changedOption:any,actionObj:any){
    this.commonService.sessionPortalLoad();
    this.commonService.loadingShow();
    this.apiService.updateActionData(actionObj,changedOption).subscribe((resData:any) => {
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.sessionPortalLoad();
        setTimeout(()=>{
          this.commonService.loadingHide();
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              this.commonService.loadingHide();
              this.commonService.commonMainObj.finalBomDataToPurchase = resData;
            }
          },error =>{
            console.log('Error in checking user session', error);   
          })
        },500);
      }else{
        this.commonService.loadingHide();
        this.commonService.commonMainObj.finalBomDataToPurchase = resData;
        console.log("this.commonService.commonMainObj.finalBomDataToPurchase",this.commonService.commonMainObj.finalBomDataToPurchase)
      }
    },error => {
      this.commonService.loadingHide();
      console.log("Error in getting PCB final quote",error);
    });
  }
  dniLineItemChange(changedOption:any,actionObj:any,issueModal:any){
    this.commonService.loadingShow();
    console.log('actionObj',actionObj);
    this.selectedDniItem = {};
    this.selectedDniItem.mpn = actionObj.mpn?actionObj.mpn:'';
    this.selectedDniItem.qty = actionObj.qtyPerBoard;
    this.selectedDniItem.refdesc = actionObj.referenceDesignator;
    this.selectedDniItem.itemNumber = actionObj.itemNo;
    this.selectedDniItem.changedOpt = changedOption;
    this.selectedDniItem.actionObjData = actionObj;
    this.levelOneIssusCheck(issueModal);
  }

  levelOneIssusCheck(levelOneIssueModal:any){
    
    this.apiService.submitMpnLevel1Check(this.selectedDniItem.actionObjData.componentId,this.commonService.commonMainObj.finalBomDataToPurchase.bomId,this.selectedDniItem).subscribe((mpnCheckData: any)=>{
      this.levelOneIssueData = mpnCheckData;
      if(mpnCheckData.status == 'Success'){
        this.commonService.loadingHide();
        this.selectedDniItem.errors = '';
        $('#errorMsg').text("");
        this.commonService.commonMainObj.isLineItemModified = false;
        this.selectedDniItem.actionObjData.mpn = this.selectedDniItem.mpn;
        this.selectedDniItem.actionObjData.qtyPerBoard = this.selectedDniItem.qty;
        this.selectedDniItem.actionObjData.referenceDesignator = this.selectedDniItem.refdesc;

        this.lineItemChange(this.selectedDniItem.changedOpt,this.selectedDniItem.actionObjData);
        setTimeout(() => {
          this.modalService.dismissAll();
        }, 3000);
      }else{
        this.commonService.loadingHide();
        if(mpnCheckData.status == 'Invalid' || mpnCheckData.errors){
          $('#errorMsg').text("Please resolve BOM Line Item issue to Continue");
          this.commonService.commonMainObj.isLineItemModified = true;
          this.selectedDniItem.errors = mpnCheckData.errors;
          if(!this.modalService.hasOpenModals()){
            this.dniItemIssuesCheckModal(levelOneIssueModal);
          }
        }
      }
    },err=>{
      if(err.error.status == 'Invalid' || err.error.errors){
        this.level1Errors = err.error.errors
        // this.commonService.alertCall("Alert!", err.error.errors);
      }else{
        this.commonService.alertCall("Alert!", 'Something went wrong, Please try again');
      }
    });
  }
  dniItemIssueModalContinue(selectedObj:any){
    for(var item in this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall.items){
      if(this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall.items[item].itemNo == selectedObj.itemNumber && this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall.items[item].mpn == selectedObj.mpn && this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall.items[item].referenceDesignator == selectedObj.refdesc && this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall.items[item].qtyPerBoard == selectedObj.qty){
        $('#errorMsg').text("Please resolve BOM Line Item issue to Continue");
        return;
      }else{
        $('#errorMsg').text("");
      }
    }
    this.levelOneIssusCheck('');
  }
  dniItemIssuesCheckModal(content:any){
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',backdrop: 'static',scrollable: true, windowClass : "lineItem-error-modal"})
    modalRef.result.then((result) => {
      console.log("result",result);
    },(reason) => {
      console.log("reason",reason);
    });
  }
  onCancel(itemNum:any){
    for(var item in this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall.items){
      if(this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall.items[item].itemNo == itemNum){
        this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall.items[item].selectedAction = 1;
      }
    }
    this.modalService.dismissAll();
  }
  getAssistRequestSessionChecked(conversationData:any,content:any){
    this.conversionData = conversationData;
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
    modalRef.result.then((result) => {
      this.commonService.sessionPortalLoad();
      this.closeResult = `Closed with: ${result}`;
      if(this.assistSubmitMsg){
        if(this.commonService.commonMainObj.userSessionMemberId != null){
          this.commonService.loadingShow();
          this.commonService.sessionPortalLoad();
          setTimeout(()=>{
            this.apiService.checkUserSessionApi().subscribe((data: any)=>{
              this.commonService.loadingHide();
              if(data.status == 1){
                this.getUpdatedBomProcureData('');
              }
            },error =>{
              console.log('Error in checking user session', error);   
            })
          },2000);
        }else{
          this.getUpdatedBomProcureData('');
        }
      }
    }, (reason) => {
      if(this.assistSubmitMsg){
        if(this.commonService.commonMainObj.userSessionMemberId != null){
          this.commonService.loadingShow();
          this.commonService.sessionPortalLoad();
          setTimeout(()=>{
            this.apiService.checkUserSessionApi().subscribe((data: any)=>{
              if(data.status == 1){
                this.getUpdatedBomProcureData('');
              }
            },error =>{
              console.log('Error in checking user session', error);   
            })
          },2000);          
        }else{
          this.getUpdatedBomProcureData('');
        }
      }
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  getAssistRequest(content:any,issuesObj:any){
    this.commonService.sessionPortalLoad();
    this.resolveData = '';
    this.assistSubmitMsg = false;
    this.postConversation = '';
    this.selectedMpnData = issuesObj;
    this.apiService.getCustomerInteraction(this.selectedMpnData.bomComponentId, this.commonService.commonMainObj.finalBomDataToPurchase.bomId).subscribe((conversationData: any)=>{
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.sessionPortalLoad();
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            this.getAssistRequestSessionChecked(conversationData,content);
          }
        },error =>{
          console.log('Error in checking user session', error);   
        })
      }else{
        this.getAssistRequestSessionChecked(conversationData,content);
      }
    },err=>{
      console.log(err)
    });
  }

  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  
  // resolveLineItem(content:any,selectedIssueObj:any){
  //   if(this.commonService.commonMainObj.userSessionMemberId != null){
  //     this.commonService.sessionPortalLoad();
  //     setTimeout(()=>{
  //       this.apiService.checkUserSessionApi().subscribe((data: any)=>{
  //         if(data.status == 1){
  //           this.resolveLineItemSessionChecked(content,selectedIssueObj);
  //         }
  //       },error =>{
  //         console.log('Error in checking user session', error);
  //       })
  //     },800);
  //   }else{
  //     this.resolveLineItemSessionChecked(content,selectedIssueObj);
  //   }
  // }

  resolveLineItem(content:any,selectedIssueObj:any) {
    this.commonService.sessionPortalLoad();
    this.level1Errors = [];
    this.selectedResolId = '';
    this.assistSubmitMsg = false;
    this.commonService.loadingShow();
    this.conversionData = '';
    this.selectedMpnData = selectedIssueObj;
    this.apiService.getResolveIssue(this.selectedMpnData.componentId, this.commonService.commonMainObj.finalBomDataToPurchase.bomId).subscribe((resolData: any)=>{
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.sessionPortalLoad();
        setTimeout(()=>{
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              this.commonService.loadingHide();
              this.resolveData = resolData.data
              this.resolveDataDuplicate = JSON.parse(JSON.stringify(this.resolveData))
              var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
              modalRef.result.then((result) => {
                this.closeResult = `Closed with: ${result}`;
              }, (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              });
            }
          },error =>{
            console.log('Error in checking user session', error);
          })
        },1000);
      }else{
        this.commonService.loadingHide();
        this.resolveData = resolData.data
        this.resolveDataDuplicate = JSON.parse(JSON.stringify(this.resolveData))
        var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
        modalRef.result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }
    },err=>{
      this.commonService.loadingHide();
      console.log(err)
    });
  }

  selectResol(selectedResolObj:any,selectedResol:any){
    if(selectedResolObj){
      this.selectedResolObj = selectedResolObj;
    }
    this.selectedResolId = selectedResol;
    this.level1Errors = [];
    if(selectedResol == 3){
      setTimeout(()=>{
        var element1:any = document.getElementById('resolve_issue_edit');
        element1.scrollIntoView({ block: 'end',  behavior: 'smooth', inline: 'end'  });  
      },300);
    }
  }

  // proceedWithResol(){
  //   if(!this.selectedResolId){
  //     this.commonService.showtoast('Please choose a resolution option to proceed','warning');
  //     return false;
  //   }
  //   if(this.commonService.commonMainObj.userSessionMemberId != null){
  //     this.commonService.sessionPortalLoad();
  //     setTimeout(()=>{
  //       this.apiService.checkUserSessionApi().subscribe((data: any)=>{
  //         if(data.status == 1){
  //           this.proceedWithResolSessionChecked();
  //         }
  //       },error =>{
  //         console.log('Error in checking user session', error);
  //       })
  //     },800); 
  //   }else{
  //     this.proceedWithResolSessionChecked();
  //   }
  // }

  proceedWithResol(){
      if(!this.selectedResolId){
      this.commonService.showtoast('Please choose a resolution option to proceed','warning');
      return false;
    }
    this.level1Errors = [];
    this.assistSubmitMsg = false;
    if(this.selectedResolId && this.selectedResolId == 3){
      if(!this.resolveDataDuplicate.qty || !this.resolveDataDuplicate.mpn || !this.resolveDataDuplicate.refdesc){
        var msgTypeText = !this.resolveDataDuplicate.qty?'quantity':!this.resolveDataDuplicate.mpn?'MPN':!this.resolveDataDuplicate.refdesc?'reference designators':'mandatory fields';
        this.commonService.alertCall("Alert!", 'Please enter '+msgTypeText);
      }else{
        this.apiService.submitMpnLevel1Check(this.selectedMpnData.componentId, this.commonService.commonMainObj.finalBomDataToPurchase.bomId,this.resolveDataDuplicate).subscribe((mpnCheckData: any)=>{
          if(mpnCheckData.status == 'Success'){
            this.resolveDataDuplicate.ref_designators = mpnCheckData.refDesignators.join()
            this.commonService.alertCall('Please wait while we price the component '+ this.resolveDataDuplicate.mpn, 'Component will be added to "Sierra will Purchase" section if issue is resolved.');
            setTimeout(()=>{
              this.submitProceedResol('loadShow',this.resolveDataDuplicate);
            },2000);
          }else{
            if(mpnCheckData.status == 'Invalid' || mpnCheckData.errors){
              this.level1Errors = mpnCheckData.errors
            }
          }
        },err=>{
          if(err.error.status == 'Invalid' || err.error.errors){
            this.level1Errors = err.error.errors
            // this.commonService.alertCall("Alert!", err.error.errors);
          }else{
            this.commonService.alertCall("Alert!", 'Something went wrong, Please try again');
          }
        });
      }
    }else if(this.selectedResolId && this.selectedResolId == 10){
      this.submitProceedResol('',this.selectedResolObj);
    }else{
      this.submitProceedResol('','');
    }
  }

  submitProceedResol(loadShow:any,mpnData:any){
    this.commonService.sessionPortalLoad();
    if(!loadShow){
      this.commonService.loadingShow();
    }
    this.apiService.submitResolutionOption(this.selectedMpnData.componentId,this.commonService.commonMainObj.finalBomDataToPurchase.bomId,this.selectedResolId,mpnData).subscribe((resolData: any)=>{
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.sessionPortalLoad();
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            if(resolData.status == 400){
              this.commonService.loadingHide();
              this.commonService.alertCall('Alert!!',resolData.message);
            }else{
              this.commonService.commonMainObj.finalBomDataToPurchase = resolData;
              this.modalService.dismissAll('Save click')
              this.commonService.loadingHide();
            }
          }
        },error =>{
          console.log('Error in checking user session', error);
        })
      }else{
        if(resolData.status == 400){
          this.commonService.loadingHide();
          this.commonService.alertCall('Alert!!',resolData.message);
        }else{
          this.commonService.commonMainObj.finalBomDataToPurchase = resolData;
          this.modalService.dismissAll('Save click')
          this.commonService.loadingHide();
        }
      }
    },err=>{
      this.commonService.loadingHide();
      // if(err.error.message && err.error.message.indexOf('already')>=0 ){
      //   this.commonService.alertCall('Alert!','This MPN is already available in BOM. Please enter correct MPN.')
      // }
      if(err.error.status == "404" || err.error.status == "400" ){
         this.commonService.alertCall('Alert!',err.error.data?err.error.data:err.error.message);
      }
      console.log(err);
    });
  }

  // subAssistRequest(issuesObj:any,msg:any){
  //   if(this.commonService.commonMainObj.userSessionMemberId != null){
  //     this.commonService.sessionPortalLoad();
  //     setTimeout(()=>{
  //       this.apiService.checkUserSessionApi().subscribe((data: any)=>{
  //         if(data.status == 1){
  //           this.subAssistRequestSessionChecked(issuesObj,msg);
  //         }
  //       },error =>{
  //         console.log('Error in checking user session', error);   
  //       })
  //     },800);   
  //   }else{
  //     this.subAssistRequestSessionChecked(issuesObj,msg);
  //   }
  // }

  subAssistRequest(issuesObj:any,msg:any){
    this.commonService.sessionPortalLoad();
    this.commonService.loadingShow();
    var message = msg;
    this.selectedMpnData = issuesObj;
    this.apiService.submitInteraction(this.selectedMpnData.bomComponentId, this.commonService.commonMainObj.finalBomDataToPurchase.bomId,message).subscribe((assistData: any)=>{
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.sessionPortalLoad();
        setTimeout(()=>{
          this.commonService.loadingHide();
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              this.conversionData = assistData;
              this.assistSubmitMsg = true;
              this.postConversation = '';
            }
          },error =>{
            console.log('Error in checking user session', error);   
          })
        },1000);
      }else{
        this.commonService.loadingHide();
        this.conversionData = assistData;
        this.assistSubmitMsg = true;
        this.postConversation = '';
      }
    },err=>{
      this.commonService.loadingHide();
      console.log(err)
    });
  }

  proceedBomAssemblySessionChecked(finAsBomRes:any){
    // this.pageShow = {
    //   "showLevel1BomItemsData" : false,
    //   "showerrorFreeBomItemsData" : false
    // }
    this.commonService.commonMainObj.assemblyQuoteJson = finAsBomRes;
    console.log("cpp result", finAsBomRes);
    if(finAsBomRes[0].assemblyLabor == null && finAsBomRes[0].quantity == null && finAsBomRes[0].turnTime == null){
      this.commonService.commonMainObj.greaterQtyResp = true;
      //update to dashboard
      var cppGreaterQtyObj={
        'redirectedToCustomQuote' :'Yes'
      }
      this.apiService.updateDetailsToDashboard(this.flowActivityId,cppGreaterQtyObj,'ComponentProcurementPage').subscribe((resDatas:any)=>{
        this.commonService.commonMainObj.backToPrevPageActivityId  = resDatas.activityId;
      },err=>{
          console.log(err)
      });
    }
    // this.assemblyPriceData();
    this.commonService.commonMainObj.selectedFabLotPrice = (parseFloat(this.commonService.commonMainObj.selectedFabPrice) * parseFloat(this.commonService.commonMainObj.selectedFabQuantity)).toFixed(2);
    if(!this.commonService.commonMainObj.backToCPPPage){
      this.commonService.loadingHide();
      setTimeout(()=>{
        this.router.navigateByUrl('/bomAssemblyProcess');
      },550);
    }else{
      for (var assmIndx in this.commonService.commonMainObj.assemblyQuoteJson) {
        if(this.commonService.commonMainObj.assemblyQuoteJson[assmIndx]['turnTime'] == this.commonService.commonMainObj.selectedAssemblyTurntime){
          this.commonService.commonMainObj.selectedAssemblyTurntime = this.commonService.commonMainObj.assemblyQuoteJson[assmIndx]['turnTime'];
          this.commonService.commonMainObj.selectedAssemblyQuantity = this.commonService.commonMainObj.assemblyQuoteJson[assmIndx]['quantity'];
          this.commonService.commonMainObj.selectedAssemblyPrice = this.commonService.commonMainObj.assemblyQuoteJson[assmIndx]['assemblyLabor'];
        }
      }
      this.reQuoteNavigateToQuoteDetails();  
    }
  }

  proceedBomAssembly(){
    this.commonService.sessionPortalLoad();
    this.commonService.loadingShow();
    
    let headerData =["Item#","Manufacturer Part Number","Vendor Part Number","Manufacturer","Footprint","DNI","Quantity","Reference Designators","Customer Will Provide","Description","Alternate MPN"];
    // var rowCount = $("#display-tbody-dni tr").length;
    // console.log("Number of rows: " + rowCount);
    //console.log("commonService.commonMainObj.finalBomDataToPurchase",this.commonService.commonMainObj.finalBomDataToPurchase);
    if(!this.commonService.commonMainObj.backToCppFromQuotePage){
      this.apiService.bomAssemblyQuoteData().subscribe((finAsBomRes: any)=>{
        if(this.commonService.commonMainObj.userSessionMemberId != null){
          this.commonService.sessionPortalLoad();
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              this.proceedBomAssemblySessionChecked(finAsBomRes);
            }
          },error =>{
            console.log('Error in checking user session', error);   
          })
        }else{
          this.proceedBomAssemblySessionChecked(finAsBomRes);
        }
        // setTimeout(()=>{
        //   window.scrollTo(0, 0);
        // },250);
      },err=>{
        this.commonService.loadingHide();
        console.log(err)
      });
    }else{
      this.apiService.updateFinalQuoteApi().subscribe((finalQuoteUpdatedData: any)=>{
        this.commonService.loadingHide();
        if(this.commonService.commonMainObj.userSessionMemberId != null){
          this.commonService.sessionPortalLoad();
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              if(finalQuoteUpdatedData){
                this.commonService.commonMainObj.pcbFinalQuotedata = finalQuoteUpdatedData;
                this.router.navigateByUrl('/quoteDetails');
              }
            }
          },error =>{
            console.log('Error in checking user session', error);   
          })
        }else{
          if(finalQuoteUpdatedData){
            this.commonService.commonMainObj.pcbFinalQuotedata = finalQuoteUpdatedData;
            this.router.navigateByUrl('/quoteDetails');
          }
        }
      },error => {
        this.commonService.loadingHide();
        console.log("Error in updating PCB final quote data",error);
      })
    }
    if(this.commonService.commonMainObj.finalBomDataToPurchase){
      if(this.commonService.commonMainObj.finalBomDataToPurchase.issueFound){
        for(var i in this.commonService.commonMainObj.finalBomDataToPurchase.issueFound?.items){
          this.attachBomData(this.commonService.commonMainObj.finalBomDataToPurchase.issueFound.items[i],'issuesFound')
          this.commonService.commonMainObj.allAvailableComponets.push(this.commonService.commonMainObj.finalBomDataToPurchase.issueFound.items[i]?.mpn);
        }
      }
      if(this.commonService.commonMainObj.finalBomDataToPurchase.okayToBuy){
        for(var i in this.commonService.commonMainObj.finalBomDataToPurchase.okayToBuy?.items){
          this.attachBomData(this.commonService.commonMainObj.finalBomDataToPurchase.okayToBuy.items[i],'okayToBuy')
          this.commonService.commonMainObj.allAvailableComponets.push(this.commonService.commonMainObj.finalBomDataToPurchase.okayToBuy.items[i]?.mpn);
        }
      }
      if(this.commonService.commonMainObj.finalBomDataToPurchase.iWillProvide){
        for(var i in this.commonService.commonMainObj.finalBomDataToPurchase.iWillProvide?.items){
          this.attachBomData(this.commonService.commonMainObj.finalBomDataToPurchase.iWillProvide.items[i],'iWillProvide')
          this.commonService.commonMainObj.allAvailableComponets.push(this.commonService.commonMainObj.finalBomDataToPurchase.iWillProvide.items[i]?.mpn);
        }
      }
      if(this.commonService.commonMainObj.finalBomDataToPurchase.customerSupport){
        for(var i in this.commonService.commonMainObj.finalBomDataToPurchase.customerSupport?.items){
          this.attachBomData(this.commonService.commonMainObj.finalBomDataToPurchase.customerSupport.items[i],'customerSupport')
          this.commonService.commonMainObj.allAvailableComponets.push(this.commonService.commonMainObj.finalBomDataToPurchase.customerSupport.items[i]?.mpn);
        }
      }
      if(this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall){
        for(var i in this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall?.items){
          this.attachBomData(this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall.items[i],'doNotInstall')
        }
      }

      let objData = {
        "header": headerData,
        "content" : this.finalBomAttachData
      }
      let formBOMQuoteData = new FormData();
      formBOMQuoteData.append('s3ZipFileName', this.commonService.commonMainObj.s3FileName);
      formBOMQuoteData.append('excelData', JSON.stringify(objData));
      setTimeout(() => {
        this.apiService.generateQuoteBOM(formBOMQuoteData).subscribe((data) =>{
          if (data.success) {
            console.log("DATA SUCCESS", data);
          }
        }, error =>{
          console.log('Bom file saving Error', error);
        })
      }, 500);
    }
    var cppLineItemCountObj = {
      "lineItemCount":{
        "okayToBuy":this.commonService.commonMainObj.finalBomDataToPurchase.okayToBuy?.items.length,
        "dni":this.commonService.commonMainObj.finalBomDataToPurchase.doNotInstall?.items.length,
        "customerSupport":this.commonService.commonMainObj.finalBomDataToPurchase.customerSupport?.items.length,
        "consigned":this.commonService.commonMainObj.finalBomDataToPurchase.iWillProvide?.items.length,
        "issues":this.commonService.commonMainObj.finalBomDataToPurchase.issueFound?.items.length

      }
    }
    this.apiService.updateDetailsToDashboard(this.flowActivityId,cppLineItemCountObj,'ComponentProcurementPage').subscribe((resDatas)=>{
    },err=>{
      console.log(err)
    });
  }

  attachBomData(datObj:any,dataSrc:any){
    let contentDataObj = [
      datObj.itemNo?datObj.itemNo:'',
      datObj.mpn?datObj.mpn:'',
      datObj.vendorPartNum?datObj.vendorPartNum:'',
      datObj.manufacturerName?datObj.manufacturerName:'',
      datObj.footprint?datObj.footprint:'',
      dataSrc == 'doNotInstall'?'DNI':'',
      datObj.buyQty?datObj.buyQty:'',
      datObj.referenceDesignator?datObj.referenceDesignator:'',
      dataSrc=='iWillProvide'?true:false,
      datObj.description?datObj.description:'',
      datObj.altMpn?datObj.altMpn:'',
    ]
    this.finalBomAttachData.push(contentDataObj)
  }
  
  getUpdatedBomProcureData(sierraSugAlt:any){
    this.commonService.loadingShow();
    this.apiService.getNewProcureMentData(this.commonService.commonMainObj.finalBomDataToPurchase.bomId).subscribe((newBomData: any)=>{
      this.commonService.loadingHide();
        this.commonService.commonMainObj.finalBomDataToPurchase = newBomData;
        if(sierraSugAlt){
          setTimeout(()=>{
            $("#sierraSugAlt").trigger('click');
          },1000);
        }
    },err=>{
      this.commonService.loadingHide();
      console.log(err)
    });
  }

  downloadBom(){
    this.commonService.loadingShow();
    if(this.commonService.commonMainObj.userSessionMemberId){
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          this.commonService.loadingHide();
          if(data.status == 1){
            var downLoadUrl = this.apiService.scaBOMFileDownloadUrl+this.commonService.commonMainObj.finalBomDataToPurchase.bomId
            downLoadUrl = this.commonService.commonMainObj.userId?downLoadUrl+ '&userId=' +this.commonService.commonMainObj.userId:downLoadUrl+ '&emailId=' +this.commonService.commonMainObj.defaultEmail;
            window.open(downLoadUrl,'_self');
          }
        },error =>{
          console.log('Error in checking user session', error);
        })
      },800);
    }else{
      var downLoadUrl = this.apiService.scaBOMFileDownloadUrl+this.commonService.commonMainObj.finalBomDataToPurchase.bomId
      downLoadUrl = this.commonService.commonMainObj.userId?downLoadUrl+ '&userId=' +this.commonService.commonMainObj.userId:downLoadUrl+ '&emailId=' +this.commonService.commonMainObj.defaultEmail;
      this.commonService.loadingHide();
      window.open(downLoadUrl,'_self');
    }
  }

  reQuoteNavigateToQuoteDetails(){
    if(this.commonService.commonMainObj.selectedFabOrgTurntime.includes("Weeks")){
      this.changedPcbTT = this.commonService.commonMainObj.selectedFabOrgTurntime.replace("Weeks", "");
      this.changedPcbTT =this.changedPcbTT*5;
    }else if(this.commonService.commonMainObj.selectedFabOrgTurntime.includes("Week")){
      this.changedPcbTT = this.commonService.commonMainObj.selectedFabOrgTurntime.replace("Week", "");
      this.changedPcbTT =this.changedPcbTT*5;
    }else{
      this.changedPcbTT = this.commonService.commonMainObj.selectedFabOrgTurntime.split(' ')[0]
    }
    var finalQuotedataObj ={
      "pcbQuantity": this.commonService.commonMainObj.selectedFabQuantity,
      "pcbTurntime": this.changedPcbTT,
      "assemblyQuantity": this.commonService.commonMainObj.selectedAssemblyQuantity,
      "assemblyTurntime": this.commonService.commonMainObj.selectedAssemblyTurntime
    }
    finalQuotedataObj.assemblyTurntime = finalQuotedataObj.assemblyTurntime.split(' ')[0]
    // this.commonService.loadingShow();
    this.apiService.createAssemblyFabFinalQuote(finalQuotedataObj).subscribe((data:any) => {
      this.commonService.loadingHide();
      if(data){
        this.commonService.commonMainObj.pcbFinalQuotedata = '';
        this.commonService.commonMainObj.pcbFinalQuotedata = data;
        this.commonService.commonMainObj.uploadedBomFileName = this.commonService.commonMainObj.uploadedFile?this.commonService.commonMainObj.uploadedFile.name:'';
        this.router.navigateByUrl('/quoteDetails');
      }
    },error => {
      this.commonService.loadingHide();
      console.log("Error in getting PCB final quote",error);
    });
  }

  sierraRecommandedAlts(content:any){
    this.commonService.commonMainObj.sierraRecommendations = this.commonService.commonMainObj.finalBomDataToPurchase.recommendations && this.commonService.commonMainObj.finalBomDataToPurchase.recommendations.length>0?this.commonService.commonMainObj.finalBomDataToPurchase.recommendations:[];
    for(var j in this.commonService.commonMainObj.sierraRecommendations){
      this.commonService.commonMainObj.sierraRecommendations[j].checkedModel = false;
    }
    if(this.commonService.commonMainObj.finalBomDataToPurchase.recommendations && this.commonService.commonMainObj.finalBomDataToPurchase.recommendations.length>0){
      this.commonService.commonMainObj.sierraRecommendations.sort(function(a:any, b:any) {
        return a.itemNo - b.itemNo;
      });
      let modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class",backdrop : 'static',keyboard : false})
      modalRef.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  selectedSierraSuggItems(){
    this.commonService.sessionPortalLoad();
    let lineItemsArray:any = {};
    lineItemsArray['bomComponentIds'] = [];
    if(this.commonService.commonMainObj.sierraRecommendations.length>0){
      this.commonService.commonMainObj.sierraRecommendations.map(function(elem:any){
        if(elem.checkedModel){
          lineItemsArray['bomComponentIds'].push(elem.bomComponentId)
        }
      })
    }
    if(lineItemsArray['bomComponentIds'].length == 0){
      this.commonService.alertCall("Alert!", 'Select at least one line item to be replaced.');
      return false;
    }
    this.commonService.loadingShow();
    this.apiService.sierraSuggested(lineItemsArray).subscribe((suggData:any) => {
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.sessionPortalLoad();
        setTimeout(()=>{
          this.commonService.loadingHide();
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              this.commonService.loadingHide();
              this.commonService.commonMainObj.finalBomDataToPurchase = suggData;
              this.modalService.dismissAll('Confirm');
            }
          },error =>{
            console.log('Error in checking user session', error);   
          })
        },500);
      }else{
        this.commonService.loadingHide();
        this.commonService.commonMainObj.finalBomDataToPurchase = suggData;
        this.modalService.dismissAll('Confirm');
      }
    },error => {
      this.commonService.loadingHide();
      console.log("Error in getting PCB final quote",error);
    });
  }
}
